export function responsibleRelatedStudentListByRespIdQuery(responsibleId) {
  const query = `{responsibleRelatedStudentListByRespId(responsibleId: ${responsibleId}) {id, type, accessStudentData, takeStudent, financialContact, emergencyContact, student{id, fullName, profilePhotoUrl, initials, legacyId, dateOfBirth}}}`;
  return query;
}

export function responsibleUnRelatedStudentListByRespIdQuery(responsibleId) {
  const query = `{responsibleUnRelatedStudentListByRespId(responsibleId: ${responsibleId}) {id, type, accessStudentData, takeStudent, financialContact, emergencyContact, student{id, fullName, profilePhotoUrl, initials, legacyId, dateOfBirth}}}`;
  return query;
}

export function responsibleStudentRelationRemoveMutation(relationId) {
  const query = `mutation {responsibleStudentRelationRemove(id: ${relationId})}`;
  return query;
}

export function responsibleStudentRelationListByStudent(studentId) {
  const query = `{responsibleStudentRelationListByStudent(filter: {studentId: ${studentId}}){id, type, accessStudentData, takeStudent, financialContact, emergencyContact, responsible{id, fullName, email, gender, phone, cellPhone, cpf, cellPhoneAux}}}`;
  return query;
}

export function getResponsibleStudentByStudentId(studentId) {
  return `{
  responsibleStudentRelationListByStudent(filter: { studentId: ${studentId} }) {
    id
    responsible {
    profilePhoto
      id
      fullName
      label
      value
    }
  }
}`;
}

export function getResponsibleStudentWithdrawByStudentId(studentId) {
  return `{
  responsibleStudentRelationListByStudentWithdraw(filter: { studentId: ${studentId} }) {
    id
    responsible {
    profilePhoto
      id
      fullName
      label
      value
    }
  }
}`;
}
